const toMyActive = myActive => {
  const obj = Object.entries(myActive)
  if (obj.length) {
    return {
      myOpenDeals: {
        title: 'My Open Opportunities',
        list: myActive.dealsInfo.map(deal => ({
          id: deal.code,
          name: deal.label,
          value: deal.count
        }))
      },
      myOpenProposals: {
        title: 'My Open Proposals',
        list: myActive.proposalsInfo.map(deal => ({
          id: deal.code,
          name: deal.label,
          value: deal.count
        }))
      }
    }
  } else {
    return {}
  }
}

export default toMyActive
